import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { toast } from "sonner";
import { z } from "zod";
import { useUpdateUserProfile } from "../api/mutations";
import { updateProfileFormSchema } from "../schemas";

type UserDetails = {
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  state: string;
  city?: string;
  date_of_birth: string;
  gender: string;
};
type Payload = {
  user_details: UserDetails;
};


type UpdateProfileFormData = z.infer<typeof updateProfileFormSchema>;

interface UseUpdateProfileProps {
  user: UserDetails | null | undefined;
}





export const useUpdateProfile = ({ user }: UseUpdateProfileProps) => {
  const updateProfileMutation = useUpdateUserProfile();

  const form = useForm<UpdateProfileFormData>({
    resolver: zodResolver(updateProfileFormSchema),
    defaultValues: {
      first_name: user?.first_name ?? "", 
      last_name: user?.last_name ?? "",
      email: user?.email ?? "",
      phone_number: user?.phone_number ?? "",
      state: user?.state ?? "",
      city: user?.city ?? "",
      date_of_birth: user?.date_of_birth ?? "",
      gender: user?.gender ?? "",
    },
  });

 
  const onSubmit = async (data: UpdateProfileFormData) => {
    try {
      const payload: Payload = {
        user_details: {
          first_name: data.first_name,
          last_name: data.last_name,
          email: data.email,
          phone_number: data.phone_number,
          state: data.state,
          // city: data.city ?? undefined,
          date_of_birth: data.date_of_birth,
          gender: data.gender,
        },
      };
      await updateProfileMutation.mutateAsync(payload);

      toast.success("Profile updated successfully");
    } catch (error) {
      console.log(error);
      toast.error("Failed to update profile");
    }
  };

  return {
    form,
    onSubmit,
    isLoading: updateProfileMutation.isPending,
  };
};
